import { Project } from '@models/project.model';

export const getProjectAccordionExpansionConfig = (
  projectIdToExpand: string | null | undefined,
  projects: Project[],
): {
  shouldExpand: boolean;
  projectExists: Project | undefined;
  elementId: string | null;
} => {
  if (!projectIdToExpand || projects.length === 0) {
    return { shouldExpand: false, projectExists: undefined, elementId: null };
  }

  const projectExists = projects.find(
    (project) => project.projectId === projectIdToExpand,
  );

  if (!projectExists) {
    return { shouldExpand: false, projectExists: undefined, elementId: null };
  }

  return {
    shouldExpand: true,
    projectExists,
    elementId: `accordion-button-${projectExists.projectId}`,
  };
};
